import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DangerousSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DangerousSVG;
